/* eslint-disable no-use-before-define */
/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import { 
	addIsSyncing, 
	removeIsSyncing, 
	addIsUnsyncing,
	removeIsUnsyncing,
	addIsDeleting,
	removeIsDeleting,
	addIsSelected,
	removeIsSelected,
	addIsDeleted,

	setJobListTab,
	setFJobs,
	setSJobs,

	setAutoFixStore,
	clearAutoFixPmCt,
	setAutoFixIsFixing,
	setAutoFixIsStopping,
	removeAutoFixPmCt

} from './actions';
import { postDeleteSurveys, postDeleteAllReadings, postUnsyncSurveys, postSyncSurveys } from './api';
import { selectAutoFixIsFixing, selectAutoFixIsStopping, selectAutoFixStoreList, selectFJobs, selectIsBusy, selectIsSelected, selectJobListTab, selectSJobs } from '../selectors';
import { selectPmctStoreMaps } from '../../PsqlCustomerPmsAndCts/selectors';

import { toTimeuuids } from '../util';
import { createCompareSurveyType } from '../../../../../scanline/redux/Lines/util/survey';
import { JOB_LIST_TAB_KEYS } from '../constants';
import UTIL from '../util.autoFixPmCt';
import JobUtil from '../../../../utils/JobUtil/JobUtil';

const AUTOFIX_DELAY = 7000;
const AUTOFIX_STOP_DELAY = 7000;

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const compareSurveyType = createCompareSurveyType('surveyType');

const thunkUnsyncSurveys = (surveys, { ignoreSleep = false, onComplete = () => {}} = {}) => (dispatch, getState) => {
	const timeuuids = toTimeuuids(surveys).filter(timeuuid => !selectIsBusy(getState(), timeuuid));
	if (timeuuids.length) {
		dispatch(addIsUnsyncing(timeuuids));
		postUnsyncSurveys(timeuuids).then(async () => {
			if (!ignoreSleep) {
				await sleep(1000);
			}
			dispatch(removeIsUnsyncing(timeuuids));
			onComplete();
		});
	}
};

const thunkSyncSurveys = (surveys, { ignoreSleep = false, onComplete = () => {}} = {}) => (dispatch, getState) => {
	const timeuuids = toTimeuuids(surveys).filter(timeuuid => !selectIsBusy(getState(), timeuuid));

	const continueSync = () => {
		if (timeuuids.length) {
			dispatch(addIsSyncing(timeuuids));
			postSyncSurveys(timeuuids).then(async () => {
				if (!ignoreSleep) {
					await sleep(1000);
				}
				dispatch(removeIsSyncing(timeuuids));
				onComplete();
			});
		}
	}

	const unsyncSurveys = surveys instanceof Array ? surveys.filter(s => s.sync) : [];

	if (!unsyncSurveys.length) {
		continueSync();
	} else {
		dispatch(thunkUnsyncSurveys(unsyncSurveys, { onComplete: continueSync }))
	}
};

const thunkDeleteSurveys = (surveys, refAllSurveys, { blnAllowDeleteAll = false, onComplete = () => {}} = {}) => (dispatch, getState) => {
	const _surveys = [...surveys];
	const _refAllSurveys = [...refAllSurveys];
	_surveys.sort(compareSurveyType);
	_refAllSurveys.sort(compareSurveyType);

	const arrSurveysDeleteReadingsOnly = [];
	if (!blnAllowDeleteAll && _surveys.length === _refAllSurveys.length) {
		// assume user is trying to delete all surveys for a job line card, which we cannot allow
		arrSurveysDeleteReadingsOnly.push(_surveys.shift());
	}

	const continueDelete = () => {
		const timeuuidsDeleteSurveys = toTimeuuids(surveys).filter(timeuuid => !selectIsBusy(getState(), timeuuid));
		if (timeuuidsDeleteSurveys.length) {
			dispatch(addIsDeleting(timeuuidsDeleteSurveys));
			postDeleteSurveys(timeuuidsDeleteSurveys).then(() => {
				dispatch(removeIsDeleting(timeuuidsDeleteSurveys));
				dispatch(removeIsSelected(timeuuidsDeleteSurveys));
				dispatch(addIsDeleted(timeuuidsDeleteSurveys));
				onComplete();
			});
		}
	}

	if (arrSurveysDeleteReadingsOnly.length) {
		dispatch(thunkDeleteAllReadings(arrSurveysDeleteReadingsOnly, { onComplete: continueDelete }));
	} else {
		continueDelete();
	}
};

const thunkDeleteAllReadings = (surveys, { preventUnsync, onComplete = () => {} } = {}) => (dispatch, getState) => {
	const timeuuids = toTimeuuids(surveys).filter(timeuuid => !selectIsBusy(getState(), timeuuid));
	if (timeuuids.length) {
		dispatch(addIsDeleting(timeuuids));
		postDeleteAllReadings(timeuuids).then(() => {
			dispatch(removeIsDeleting(timeuuids));
			dispatch(removeIsSelected(timeuuids));
			if (preventUnsync) {
				onComplete();
			} else { 
				dispatch(thunkUnsyncSurveys(timeuuids, { ignoreSleep: true, onComplete }));
			}
		});
	}
};

const thunkToggleAllIsSelected = (surveys) => (dispatch, getState) => {
	const timeuuids = toTimeuuids(surveys);
	const state = getState();
	const hasSomeSelected = timeuuids.some(id => selectIsSelected(state, id));
	if (hasSomeSelected) {
		dispatch(removeIsSelected(timeuuids));
	} else {
		dispatch(addIsSelected(timeuuids));
	}
};

const _thunkComputeAutoFixStore = (jobs) => (dispatch, getState) => {
	dispatch(clearAutoFixPmCt());
	const _maps = selectPmctStoreMaps(getState());
	if (!jobs?.length || !Object.keys(_maps)?.length) {
		return;
	}

	let autoFixStore = UTIL.clearAutoFixPmCt(); // instantiate new auto fix store

	(jobs || []).forEach(job => {
		const lineNames = Object.keys((job?.lines || {}));
		lineNames.forEach(lineName => {
			const surveys = job?.lines?.[lineName] || {};
			const { customer, job: jobNumber } = job || {};
			const { projectManager: pm, ct } = surveys[0];

			const pmMatch = _maps[customer]?.pms?.userid?.[pm];
			const pmPossiblity = _maps[customer]?.pms?.name?.[pm];
			if (!pmMatch && pmPossiblity) {
				autoFixStore = UTIL.addAutoFixPmCt({ autoFixStore, customer, jobNumber, lineName, surveys, pm: { from: pm, to: pmPossiblity?.userid } })
			}


			const ctMatch = _maps[customer]?.cts?.userid?.[ct];
			const ctPossiblity = _maps[customer]?.cts?.name?.[ct];
			if (!ctMatch && ctPossiblity) {
				autoFixStore = UTIL.addAutoFixPmCt({ autoFixStore, customer, jobNumber, lineName, surveys, ct: { from: ct, to: ctPossiblity?.userid } })
			}

		})
	});

	// console.log(autoFixStore);

	dispatch(setAutoFixStore(autoFixStore));
}

const thunkSetJobsListTab = (tab) => (dispatch, getState) => {
	const current = {
		tab: selectJobListTab(getState()),
		fjobs: selectFJobs(getState()),
		sjobs: selectSJobs(getState()),
	}

	if (tab === current.tab) {
		return;
	}

	switch(tab) {
		case JOB_LIST_TAB_KEYS.FILTER:						
			dispatch(_thunkComputeAutoFixStore(current.fjobs))
			break;
		case JOB_LIST_TAB_KEYS.SEARCH:
			dispatch(_thunkComputeAutoFixStore(current.sjobs))
			break;
		default:
			dispatch(clearAutoFixPmCt());
	}
	dispatch(setJobListTab(tab));
}

const thunkSetFJobs = (fjobs) => (dispatch, getState) => {
	const current = {
		tab: selectJobListTab(getState()),
		fjobs: selectFJobs(getState()),
	}

	if (fjobs === current.fjobs) {
		return;
	}

	if (current.tab === JOB_LIST_TAB_KEYS.FILTER) {
		dispatch(_thunkComputeAutoFixStore(fjobs))
	}

	dispatch(setFJobs(fjobs));
}

const thunkSetSJobs = (_sjobs) => (dispatch, getState) => {
	const current = {
		tab: selectJobListTab(getState()),
		sjobs: selectSJobs(getState()),
	}

	const sjobs = _sjobs?.length === 1 && _sjobs[0] instanceof Array ? _sjobs[0] : _sjobs;

	if (sjobs === current.sjobs) {
		return;
	}

	if (current.tab === JOB_LIST_TAB_KEYS.SEARCH) {
		dispatch(_thunkComputeAutoFixStore(sjobs))
	}

	dispatch(setSJobs(sjobs));
}

const thunkForceComputeAutoFixStore = () => (dispatch, getState) => {
	const current = {
		tab: selectJobListTab(getState()),
		fjobs: selectFJobs(getState()),
		sjobs: selectSJobs(getState()),
	}

	dispatch(clearAutoFixPmCt());
	switch(current.tab) {
		case JOB_LIST_TAB_KEYS.FILTER:			
			dispatch(_thunkComputeAutoFixStore(current.fjobs))
			break;
		case JOB_LIST_TAB_KEYS.SEARCH:
			dispatch(_thunkComputeAutoFixStore(current.sjobs))
			break;
		default:
			// do nothing
	}
}

const _savePM = (item, onComplete = () => {}) => {
	if (item?.pm?.to) {
		JobUtil.updateLineLevelDetails(
			{
				updatedValue: item.pm.to.trim(),
				jobguids: item?.surveys || [],
				key: 'projectManager'
			}, 
			(err, res) => {
				onComplete();
			}
		)
	} else {
		onComplete();
	}
};
const _saveCT = (item, onComplete = () => {}) => {
	if (item?.ct?.to) {
		JobUtil.updateLineLevelDetails(
			{
				updatedValue: item.ct.to.trim(),
				jobguids: item?.surveys || [],
				key: 'ct'
			}, 
			(err, res) => {
				onComplete();
			}
		)
	} else {
		onComplete();
	}
};

const _saveAutoFix = (item) => {
	_savePM(item, () => {
		_saveCT(item)
	})
}

const _thunkAutoFixFixNext = ({ onComplete = () => {} } = {}) => (dispatch, getState) => {
	const isFixing = selectAutoFixIsFixing(getState());
	const isStopping = selectAutoFixIsStopping(getState());
	if (isFixing && !isStopping) {
		const list = selectAutoFixStoreList(getState());
		const pendingItem = list[0];
		if (!pendingItem) {
			dispatch(setAutoFixIsFixing(false));
			dispatch(setAutoFixIsStopping(false));
			onComplete();
		} else {
			_saveAutoFix(pendingItem);
			setTimeout(() => {
				dispatch(removeAutoFixPmCt(pendingItem));
				dispatch(_thunkAutoFixFixNext({ onComplete }));
			}, AUTOFIX_DELAY);
		}		
	}
}

const thunkStartAutoFix = ({ onComplete = () => {} } = {}) => (dispatch, getState) => {
	const list = selectAutoFixStoreList(getState());
	if (list?.length) {
		dispatch(setAutoFixIsFixing(true));
		dispatch(_thunkAutoFixFixNext({ onComplete }));
	}
}

const thunkStopAutoFix = ({ onComplete = () => {} } = {}) => (dispatch, getState) => {
	const isFixing = selectAutoFixIsFixing(getState());
	if (isFixing) {
		dispatch(setAutoFixIsStopping(true));
		setTimeout(() => {
			dispatch(setAutoFixIsFixing(false));
			dispatch(setAutoFixIsStopping(false));
			onComplete();
		}, AUTOFIX_STOP_DELAY)
	}
}

export { 
	thunkUnsyncSurveys, 
	thunkSyncSurveys, 
	thunkDeleteSurveys, 
	thunkDeleteAllReadings, 
	thunkToggleAllIsSelected,
	thunkSetJobsListTab,
	thunkSetFJobs,
	thunkSetSJobs,
	thunkForceComputeAutoFixStore,
	thunkStartAutoFix,
	thunkStopAutoFix,
};
